<template>
  <div class="next-btn-container-mobile">
    <div class="row justify-content-between">
      <div class="col-5">
        <b-button
          @click="back()"
          class="back-button btn-ripple"
          variant="outline-light"
        >
          <img class="arrow" src="../../../../assets/arrow.svg" alt />
          {{ $tc("message.backAndNext", 1) }}
        </b-button>
      </div>
      <div  v-if="infoCard === 'yes'" class="col-1 text-right selfalign">
        <img
          
          class="alert-inf"
          @click="launchInfo()"
          src="../../../../assets/alert.svg"
          alt
        />
      </div>
      <div v-if="infoCard === 'no'" class="col-1 text-right pl-0">
        
      </div>
      
      <div v-if="nextBtn === 'yes'" class="col-5 text-right pl-0">
        <b-button
          @click="next()"
          class="next-button btn-ripple next-button-color"
          variant="primary"
          :disabled="disabled"
          >{{ $tc("message.backAndNext", 0) }}</b-button
        >
      </div>
      <div class="col-6">
        <b-button
          v-if="payBtn === 'yes'"
          @click="pay()"
          class="next-button btn-ripple next-button-color"
          variant="primary"
          >Pay Now</b-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["disabled", "info", "nextbtn", "paybtn"],
  name: "store-footer-mobile",
  data: function () {
    return {
      infoCard: this.info,
      nextBtn: this.nextbtn,
      payBtn: this.paybtn,
    };
  },
  methods: {
    back() {
      this.$emit("back");
    },
    next() {
      this.$emit("next");
    },
    launchInfo() {
      this.$emit("LInfo");
    },
    pay() {
      this.$emit("payN");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>